define('app/ui/map/map.styles',[],function () {

	var styles = [
		{
			"featureType": 'all',
			"elementType": 'labels',
			"stylers": [
				{
					"visibility": 'off'
				}
			]
		},
		{
			"featureType": 'all',
			"elementType": 'labels.text',
			"stylers": [
				{
					"visibility": 'off'
				}
			]
		},
		{
			"featureType": 'administrative',
			"elementType": 'all',
			"stylers": [
				{
					"visibility": 'off'
				},
				{
					"color": '#efebe2'
				}
			]
		},
		{
			"featureType": 'administrative',
			"elementType": 'labels.text',
			"stylers": [
				{
					"visibility": 'off'
				}
			]
		},
		{
			"featureType": 'administrative',
			"elementType": 'labels.text.fill',
			"stylers": [
				{
					"color": '#000000'
				}
			]
		},
		{
			"featureType": 'administrative',
			"elementType": 'labels.text.stroke',
			"stylers": [
				{
					"color": '#ff0000'
				},
				{
					"visibility": 'simplified'
				}
			]
		},
		{
			"featureType": 'administrative.locality',
			"elementType": 'labels.text',
			"stylers": [
				{
					"visibility": 'simplified'
				}
			]
		},
		{
			"featureType": 'administrative.neighborhood',
			"elementType": 'labels.text',
			"stylers": [
				{
					"color": '#000000'
				}
			]
		},
		{
			"featureType": 'landscape',
			"elementType": 'all',
			"stylers": [
				{
					"color": '#efebe2'
				}
			]
		},
		{
			"featureType": 'landscape',
			"elementType": 'geometry.fill',
			"stylers": [
				{
					"color": '#e9e8e8'
				}
			]
		},
		{
			"featureType": 'poi',
			"elementType": 'all',
			"stylers": [
				{
					"color": '#efebe2'
				}
			]
		},
		{
			"featureType": 'poi.attraction',
			"elementType": 'all',
			"stylers": [
				{
					"color": '#efebe2'
				}
			]
		},
		{
			"featureType": 'poi.business',
			"elementType": 'all',
			"stylers": [
				{
					"color": '#efebe2'
				}
			]
		},
		{
			"featureType": 'poi.government',
			"elementType": 'all',
			"stylers": [
				{
					"color": '#dfdcd5'
				}
			]
		},
		{
			"featureType": 'poi.medical',
			"elementType": 'all',
			"stylers": [
				{
					"color": '#dfdcd5'
				}
			]
		},
		{
			"featureType": 'poi.park',
			"elementType": 'all',
			"stylers": [
				{
					"color": '#bad294'
				}
			]
		},
		{
			"featureType": 'poi.park',
			"elementType": 'geometry.fill',
			"stylers": [
				{
					"color": '#e9e8e8'
				}
			]
		},
		{
			"featureType": 'poi.place_of_worship',
			"elementType": 'all',
			"stylers": [
				{
					"color": '#efebe2'
				}
			]
		},
		{
			"featureType": 'poi.school',
			"elementType": 'all',
			"stylers": [
				{
					"color": '#efebe2'
				}
			]
		},
		{
			"featureType": 'poi.sports_complex',
			"elementType": 'all',
			"stylers": [
				{
					"color": '#efebe2'
				}
			]
		},
		{
			"featureType": 'road',
			"elementType": 'labels',
			"stylers": [
				{
					"visibility": 'simplified'
				}
			]
		},
		{
			"featureType": 'road.highway',
			"elementType": 'geometry.fill',
			"stylers": [
				{
					"color": '#ffffff'
				}
			]
		},
		{
			"featureType": 'road.highway',
			"elementType": 'geometry.stroke',
			"stylers": [
				{
					"visibility": 'off'
				}
			]
		},
		{
			"featureType": 'road.arterial',
			"elementType": 'geometry.fill',
			"stylers": [
				{
					"color": '#ffffff'
				}
			]
		},
		{
			"featureType": 'road.arterial',
			"elementType": 'geometry.stroke',
			"stylers": [
				{
					"visibility": 'off'
				}
			]
		},
		{
			"featureType": 'road.local',
			"elementType": 'geometry.fill',
			"stylers": [
				{
					"color": '#fbfbfb'
				}
			]
		},
		{
			"featureType": 'road.local',
			"elementType": 'geometry.stroke',
			"stylers": [
				{
					"visibility": 'off'
				}
			]
		},
		{
			"featureType": 'transit',
			"elementType": 'all',
			"stylers": [
				{
					"visibility": 'off'
				}
			]
		},
		{
			"featureType": 'water',
			"elementType": 'all',
			"stylers": [
				{
					"color": '#a5d7e0'
				}
			]
		},
		{
			"featureType": 'water',
			"elementType": 'geometry.fill',
			"stylers": [
				{
					"color": '#bee2e9'
				}
			]
		},
		{
			"featureType": 'water',
			"elementType": 'labels',
			"stylers": [
				{
					"visibility": 'simplified'
				},
				{
					"color": '#000000'
				}
			]
		}
	];

	return styles;

});
